var slickInit;

(function($){
	
	slickInit = function(){
		
		
		$('.c-news-slider').slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			dots: true,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 700,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 2
					}
				}
			]
		});
		
	}
	
})(jQuery);
	
	
export default slickInit;